export default {
    despachos: {
        titulo: "Despacho Gas Oil y Lubricantes",
        nuevo: "Nuevo despacho",
        editar: "Modificar despacho",
        matricula: "Matrícula",
        responsable: "Responsable",
        fechaIni: "Fecha inicio",
        fechaFin: "Fecha fin",
        fecha: "Fecha",
        kmsHs: "Kms/Hs",
        gasoil: "Gas Oil",
        aceiteHidraulico: "Aceite Hidráulico",
        aceiteMotor: "Aceite Motor",
        cambioAceite: "Se realizó cambio de aceite",
        otros: "Otros",
        tipoEquipo: "Tipo de equipo",
        marca: "Marca",
        modelo: "Modelo",
        obra: "Obra",
        ultimosDespachos: "Últimos despachos del equipo",
        confirmar: "Confirmar",
        eliminar: "Eliminar",
        pregEliminar: "¿Desea eliminar el despacho?",
        eliminarTitulo: "Eliminar despacho",
        importar: "Importar",
        importarTitulo: "Importar despachos desde Excel del surtidor",
        seleccionarArchivo: "Archivo del surtidor (.xlsx)",
        analizarArchivo: "Analizar archivo",
        confirmarImportacion: "Confirmar importación",
        filasLeidas: "Filas leídas",
        filasImportables: "A importar",
        filasDuplicadas: "Duplicadas (se saltean)",
        filasConError: "Con error (se saltean)",
        importadosOk: "Se importaron {n} despachos",
        fila: "Fila",
        estado: "Estado",
        motivo: "Motivo",
        estadoOk: "A importar",
        estadoDuplicado: "Duplicado",
        estadoError: "Error",
    },
    planilla: {
        titulo: "Control Gasoil y Aceite de Vehículos",
        resumenMensual: "Resumen mensual",
        promedioGasoil: "Promedio Gas Oil",
        tipo: "Tipo",
        litros: "Litros",
        totales: "TOTALES",
        valoresTotalesAl: "Valores totales al",
        ultimoCambio: "Último cambio de aceite",
        proximoCambio: "Próximo cambio de aceite",
        cambio: "Cambio",
        actual: "Actual",
        proximo: "Próximo",
        estado: "Estado",
        mes: "Mes",
        kms: "Kms",
        kmsLts: "Kms/Lts",
    },
    cambiosAceite: {
        titulo: "Vehículos para Cambio de Aceite",
        vehiculo: "Vehículo",
        ultimoCambio: "Último cambio de aceite",
        actual: "Actual",
        proximoCambio: "Próximo cambio de aceite",
        vencido: "Vencido",
    },
    alertas: {
        titulo: "Consumos Gasoil Fuera de Rango",
        mes: "Mes",
        vehiculo: "Vehículo",
        consumo: "Consumo fuera de rango",
        consumoMinimo: "Consumo mínimo",
        consumoMaximo: "Consumo máximo",
        eliminar: "Eliminar alerta",
        pregEliminar: "¿Desea eliminar la alerta?",
    },
    proximosMantenimientos: {
        titulo: "Próximos Mantenimientos",
        equipo: "Equipo",
        plan: "Plan de mantenimiento",
        actual: "Kms/Hs actual",
        proximo: "Próximo mantenimiento",
        crearServicio: "Crear servicio",
        servicioCreado: "Servicio creado con éxito",
        enProceso: "Servicio en proceso",
    },
    dashboard: {
        cambioAceite: "CAMBIO DE ACEITE",
        proximoCambio: "Cambio de aceite próximo",
        ultimoCambio: "Cambio de aceite último",
        kmsHs: "Kms/Hs",
        estado: "Estado",
    },
};
